import {
  WORKFLOW_CONDITION_IS_TODAY,
  WORKFLOW_CONDITION_PLUS_X_HOURS_IS_NOW,
  //
  WORKFLOW_FIELD_TYPE_DATETIME,
  WORKFLOW_FIELD_TYPE_DD_MM,
  //
  WORKFLOW_FIELD_TYPE_DD_MM_YYYY,
  WORKFLOW_FIELD_TYPE_INTEGER,
  WORKFLOW_FIELD_TYPE_MM_DD,
  WORKFLOW_FIELD_TYPE_MM_DD_YYYY,
  WORKFLOW_FIELD_TYPE_MMDD,
  WORKFLOW_FIELD_TYPE_TEXT,
  WORKFLOW_FIELD_TYPE_YYYY_MM_DD,
  WORKFLOW_FIELD_TYPE_YYYYMMDD
} from 'Constants/'
import { FormElement, Select } from 'mailup-web-components'
import { allFieldTypes } from 'Pages/Workflow/recoil/state/data'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useMemo, useState } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const dateConditions = [
  WORKFLOW_FIELD_TYPE_DD_MM_YYYY,
  WORKFLOW_FIELD_TYPE_DD_MM,
  WORKFLOW_FIELD_TYPE_MM_DD_YYYY,
  WORKFLOW_FIELD_TYPE_MM_DD,
  WORKFLOW_FIELD_TYPE_YYYYMMDD,
  WORKFLOW_FIELD_TYPE_MMDD,
  WORKFLOW_FIELD_TYPE_YYYY_MM_DD
]

const InputFieldType = () => {
  const intl = useIntl()
  const [isDirty, setIsDirty] = useState(false)

  const { FieldType } = useRecoilValue(step2State)
  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const handleChangeFieldType = (value) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      FieldType: value,
      IdFieldFilter: dateConditions.includes(value)
        ? WORKFLOW_CONDITION_IS_TODAY // se FieldType di tipo data => default condition è today
        : value === WORKFLOW_FIELD_TYPE_DATETIME
          ? WORKFLOW_CONDITION_PLUS_X_HOURS_IS_NOW // se FieldType è datetime => condition può essere solo plus x hours is now
          : '',
      FieldValue:
        value === WORKFLOW_FIELD_TYPE_DATETIME
          ? 1 // se FieldType è datetime => FieldValue di default a 1
          : value === WORKFLOW_FIELD_TYPE_INTEGER
            ? '0' // se FieldType è integer => FieldValue di default a 0
            : value === WORKFLOW_FIELD_TYPE_TEXT
              ? ''
              : prev.FieldValue
      // ? prev.FieldValue
      // : '1'
    }))
    setIsDirty(true)
  }

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  const fieldTypeOptions = useMemo(() => {
    return allFieldTypes.map(({ label, value }) => ({
      value,
      label: intl.formatMessage({ id: label })
    }))
  }, [])

  const invalid = isDirty && !FieldType

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.AutomationWorkflow.SelectTypeConditionLabel'
      })}
      required
      feedback={invalid ? requiredFeedback : undefined}
      variant={invalid ? 'danger' : undefined}
    >
      <Select
        value={FieldType}
        options={fieldTypeOptions}
        placeholder={intl.formatMessage({
          id: 'Load.AutomationWorkflow.SelectTypeConditionPlaceholder'
        })}
        onChange={handleChangeFieldType}
        error={invalid}
      />
    </FormElement>
  )
}

export default InputFieldType
